import * as React from "react"

function SvgBusinessResults(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      vectornator="http://vectornator.io"
      viewBox="0 0 211 174"
      fillRule="evenodd"
      clipRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <g layerName="Livello 1">
        <path
          d="M137.644 154.821c0-2.712 16.421-4.911 36.678-4.911 20.257 0 36.678 2.199 36.678 4.911 0 2.712-16.421 4.911-36.678 4.911-20.257 0-36.678-2.199-36.678-4.911z"
          fillOpacity={0.186}
          fill="#2196f3"
        />
        <path
          d="M8.26 94.814h1.433v1.195H8.259v-1.195zM145.298 96.009h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0H91.62v-1.195h2.825v1.195zm-5.65 0H85.97v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0H74.67v-1.195h2.825v1.195zm-5.65 0H69.02v-1.195h2.826v1.195zm-5.65 0H63.37v-1.195h2.825v1.195zm-5.651 0H57.72v-1.195h2.825v1.195zm-5.65 0H52.07v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.826v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195zM8.26 64.469h1.433v1.194H8.259V64.47zM145.298 65.663h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.651 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0H91.62V64.47h2.825v1.194zm-5.65 0H85.97V64.47h2.825v1.194zm-5.651 0h-2.825V64.47h2.825v1.194zm-5.65 0H74.67V64.47h2.825v1.194zm-5.65 0H69.02V64.47h2.826v1.194zm-5.65 0H63.37V64.47h2.825v1.194zm-5.651 0H57.72V64.47h2.825v1.194zm-5.65 0H52.07V64.47h2.825v1.194zm-5.65 0h-2.826V64.47h2.826v1.194zm-5.65 0h-2.826V64.47h2.825v1.194zm-5.651 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.825V64.47h2.825v1.194zm-5.65 0h-2.826V64.47h2.825v1.194zm-5.65 0h-2.826V64.47h2.825v1.194zM8.26 34.123h1.433v1.195H8.259v-1.195zM145.298 35.318h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0H91.62v-1.195h2.825v1.195zm-5.65 0H85.97v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0H74.67v-1.195h2.825v1.195zm-5.65 0H69.02v-1.195h2.826v1.195zm-5.65 0H63.37v-1.195h2.825v1.195zm-5.651 0H57.72v-1.195h2.825v1.195zm-5.65 0H52.07v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.826v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195zm-5.651 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.825v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195zm-5.65 0h-2.826v-1.195h2.825v1.195z"
          fill="#e6e6e6"
        />
        <path d="M43.264 95.172h11.708v43.01H43.264v-43.01z" fill="#00bfa6" />
        <path d="M45.414 95.172h11.709v43.01H45.413v-43.01z" fill="#2196f3" />
        <path d="M70.981 64.827h11.708v73.355H70.981V64.827z" fill="#00bfa6" />
        <path d="M73.132 64.827H84.84v73.355H73.13V64.827z" fill="#2196f3" />
        <path d="M98.698 34.482h11.708v103.7H98.698v-103.7z" fill="#00bfa6" />
        <path d="M100.849 34.482h11.708v103.7h-11.708v-103.7z" fill="#2196f3" />
        <path
          d="M5.511 34.72a2.867 2.867 0 115.735 0 2.867 2.867 0 01-5.735 0zM5.511 65.066a2.867 2.867 0 115.735 0 2.867 2.867 0 01-5.735 0zM5.511 95.412a2.867 2.867 0 115.735 0 2.867 2.867 0 01-5.735 0z"
          fill="#e6e6e6"
        />
        <path d="M-1.179 137.914H211v.535H-1.179v-.535z" fill="#2196f3" />
        <path
          d="M171.409 32.95a8.133 8.133 0 1116.266 0 8.133 8.133 0 01-16.266 0z"
          fill="#2f2e41"
        />
        <path
          d="M159.869 86.472l-.439 2.638s-2.418 9.012.659 8.572c3.078-.44 1.978-8.133 1.978-8.133l.44-2.417-2.638-.66z"
          fill="#ffb9b9"
        />
        <path
          d="M187.016 74.053h-17.805s-5.055 7.913-3.077 21.761c1.978 13.848 1.099 44.841 1.099 44.841h6.814l4.616-48.578 9.671 48.578 6.375-.66-3.517-56.05-4.176-9.892z"
          fill="#2f2e41"
        />
        <path
          d="M169.101 139.885l-.22 8.133s-2.857 8.133 1.319 7.254c4.177-.879 4.616-2.638 4.616-3.297 0-.66-1.099-12.09-1.099-12.09h-4.616zM193.592 139.267l1.258 8.698s3.875 7.7-.38 7.362c-4.254-.337-4.915-2.025-5-2.679-.084-.654-.456-12.79-.456-12.79l4.578-.591z"
          fill="#2f2e41"
        />
        <path
          d="M173.717 35.037a5.935 5.935 0 1111.87 0 5.935 5.935 0 01-11.87 0z"
          fill="#ffb9b9"
        />
        <path
          d="M184.158 37.565l2.418 8.353-4.836 4.836-2.638-4.616-.879-6.594 5.935-1.979z"
          fill="#ffb9b9"
        />
        <path
          d="M186.246 43.17s-.323-2.217-1.041-1.988c-.717.23-7.092 1.768-7.092 2.428v2.857l-5.275 20.442-1.319 8.353 13.848-.22 2.198-29.014-1.319-2.858z"
          fill="#e6e6e6"
        />
        <path
          d="M185.037 40.862l1.539.44 2.528 2.528s6.154-1.1 7.034 1.758c.879 2.858-4.836 38.466-4.836 38.466s-9.672 3.297-11.21-5.055c-1.539-8.353-1.429-15.497 1.648-20.772 3.077-5.275 3.297-17.365 3.297-17.365zM178.661 42.824l-.877.456-.77 3.407s-6.374 1.759-6.814 4.177c-.439 2.417.22 15.606.22 15.606s-6.154 12.529-5.055 17.804c0 0 2.637 2.198 4.616-.66 1.978-2.857 6.814-20.002 7.033-21.1.22-1.1 2.634-19.377 1.647-19.69z"
          fill="#2f2e41"
        />
        <path
          d="M172.618 49.984l-2.353.638-1.603 4.638-3.297 11.87-6.375 19.562 4.396 1.978 7.034-14.287 2.198-24.399zM184.158 34.268c-3.779-1.363-5.058-2.2-9.232 0l-1.538-6.155h12.309l-1.539 6.155z"
          fill="#2f2e41"
        />
        <path
          d="M174.267 24.377a4.616 4.616 0 119.231-.001 4.616 4.616 0 01-9.231 0z"
          fill="#2f2e41"
        />
        <path
          d="M173.388 23.278a4.612 4.612 0 014.396-4.605c-.074-.004-.146-.011-.22-.011a4.616 4.616 0 000 9.232c.074 0 .146-.008.22-.011a4.612 4.612 0 01-4.396-4.605z"
          fill="#2f2e41"
        />
        <path
          d="M186.938 82.834l-1.006 2.478s-2.658 8.944-5.05 6.959c-2.392-1.986 2.572-7.965 2.572-7.965l.891-2.29 2.593.818z"
          fill="#ffb9b9"
        />
        <path
          d="M193.06 46.248l3.078-.66a32.188 32.188 0 011.06 3.957c.44 2.198-.239 19.563-.678 21.32-.44 1.76-8.411 13.476-8.411 13.476l-7.173-1.556 10.366-15.656 1.758-20.882z"
          fill="#2f2e41"
        />
        <path
          d="M191.407 57.42l-1.912 10.513-7.168 14.576 6.452-15.292 2.628-9.797z"
          opacity={0.2}
        />
      </g>
    </svg>
  )
}

export default SvgBusinessResults
